/**
 * Created by sairam on 25/04/17.
 */
import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { setItem } from 'utils/localStorage';
import * as service from './../../common/services/session.service';
import { REGISTER_REQUESTED, REGISTER_FAILED, REGISTER_SUCCESSFUL } from './RegisterActionTypes';

export default function registerUser(username, password, attributes) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REGISTER_REQUESTED,
    });
    service.RegisterUser(username, password, attributes, (err, result) => {
      if (err) {
        dispatch({
          type: REGISTER_FAILED,
          error: {
            code: err.code,
            message: err.message,
          },
        });
      } else {
                // Storing token in to local storage
               // const token = result.session.idToken.jwtToken;
        setItem('isLoggedIn', true);
        // setItem('token', token);
                // end of dangerous code
        dispatch({
          type: REGISTER_SUCCESSFUL,
          session: fromJS(result.session),
          user: fromJS(result.user),
          // token,
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/containers/Register/Register.actions.js